import Loading from "./Loading";

export * from './Loading';

export default Loading;
